import React from 'react';

import AnalyticsWebClient from '@atlassiansox/analytics-web-client';

import { cssMap } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

interface PreviewPanelBodyProps {
	children: React.ReactNode;
	parentProduct?: string;
	panelType?: string;
	analyticsClient?: AnalyticsWebClient | undefined | null;
}

const styles = cssMap({
	wrapper: {
		flexGrow: 1,
		overflow: 'auto',
		paddingInlineStart: token('space.200'),
		paddingInlineEnd: token('space.200'),
	},
});

export const PreviewPanelBody = ({
	children,
	analyticsClient,
	parentProduct,
	panelType,
}: PreviewPanelBodyProps) => {
	React.useEffect(() => {
		if (analyticsClient) {
			analyticsClient.sendTrackEvent({
				action: 'viewed',
				actionSubject: 'preview-panel',
				actionSubjectId: 'preview-panel-view',
				source: 'preview-panel',
				attributes: {
					parentProduct,
					panelType,
				},
			});
		}
	}, [analyticsClient, parentProduct, panelType]);

	return <Flex xcss={styles.wrapper}>{children}</Flex>;
};
